// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2o-3";
export var dialog = "_2o-0";
export var divClassnameSwatch = "_2o-8";
export var flexSwatch = "_2o-4";
export var header = "_2o-1";
export var styleAttributeSwatch = "_2o-7";
export var swatch = "_2o-2";
export var textHeaderSwatch = "_2o-5";
export var webSwatch = "_2o-6";